import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types'

// Redux
import { connect } from 'react-redux';

// Actions
import { setAlert } from '../../../actions/alertActions';

// Components - material UI
import { Button } from '@material-ui/core';

// Icons - material UI
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import LockIcon from '@material-ui/icons/Lock';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';
import isSchoolEmail from '../../../utils/reusable_functions/isSchoolEmail';

const School_Email = ({
    school_email,
    onChange,
    auth,
    chat,
    notification,
    getUnreadChats,
    getUnreadCount,
    history,
    goBack,
    setAlert,
    nav: {
        website,
        valid_Email_Exts
    }
}) => {

    // Screen Width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // Notification Badge
    const [badgeValue, setBadgeValue] = useState(0);

    // Get the current URL and extract the "filter" parameter
    const url_filter = (window.location.href);
    const url = new URL(url_filter);
    const url_campus_id = url.searchParams.get("campus");

    useEffect(() => {

        // Add event listener for window resize
        window.addEventListener('resize', () => handleWindowSizeChange());

        // Cleanup the event listener when the component unmounts
        return () => window.removeEventListener('resize', () => handleWindowSizeChange());
    }, []);

    // Update window width state on window resize
    const handleWindowSizeChange = () => {
        setWindowWidth(window.innerWidth);
    };

    useEffect(() => {

        // Fetch unread counts for notifications and chats
        if(auth.user){
            getUnreadCount(auth.user._id);
            getUnreadChats(auth.user._id);
        }

    }, [notification.notifications, auth.user]);

    useEffect(() => {

        // Update the badge value to total (Notifications + unread Chats)
        setBadgeValue(notification.num_unread + chat.num_unread_chats);

    }, [notification.num_unread, chat.num_unread_chats])

    // Determine mobile and tablet screen sizes
    const isMobile = windowWidth <= 769;
    const isTablet = windowWidth <= 1000;

    const school_email_todo = () => {

        if(valid_Email_Exts?.length > 0) {
            if(school_email.length > 0 && school_email !== auth.user.school_email) {
                if(isSchoolEmail(school_email, valid_Email_Exts)) {
                    if(url_campus_id) {
                        window.location.href = `/settings/account/verify_school_email?email=${school_email}&campus=${url_campus_id}`;
                    } else {
                        window.location.href = `/settings/account/verify_school_email?email=${school_email}`;
                    }
                } else {
                    setAlert('Enter a valid school email','danger')
                }
                
            } else {
                setAlert('Enter a new school email','danger')
            }
        } else {
            setAlert('Something went wrong','danger')
        }
        
    }

    return (
        <div className="settings">

            {/* Header */}
            <div className="settings__header">

                {/* Back Btn Icon & Badge Value */}
                <div onClick={goBack} className="profile__btnContainer">
                    <ArrowBackIcon />
                    {isMobile && badgeValue > 0 ? (
                        <span className="feed-header-badge defaultBadge">
                            {badgeValue}
                        </span>
                    ) : null}
                </div>

                {/* Title */}
                <div className="settings__headerText">
                    {school_email === '' ? (
                        <h3>
                            Join your campus
                        </h3>
                    ) : (
                        <h3>
                            Change school email
                        </h3>
                    )}
                    
                </div>
            </div>

            {/* Body */}
            <div className="settings__body">

                {website && (
                    <div style={{width: '100%', boxSizing:'border-box', padding:'10px', display:'flex', justifyContent:'flex-start'}}>

                        {/* Disclaimer text */}
                        <div style={{color: 'rgb(83, 100, 113)', fontSize:'15px', lineHeight: '20px', fontWeight:'500', overflowWrap:'break-word'}}>
                            <span>Enter your official student email to join: </span>
                            <br/>
                            <span style={{color: 'rgb(29, 155, 240)', fontWeight: 'bold'}}>{website.name}</span>
                        </div>
                    </div>
                )}

                {/* Input */}
                <div style={{width: '100%', boxSizing:'border-box', padding:'10px', display:'flex', flexDirection: 'column', justifyContent:'center', borderBottom:'1px solid #e6ecf0'}}>
                    <input
                        type="email"
                        placeholder="Enter school email(.edu)"
                        className="input"
                        name="school_email"
                        value={school_email}
                        onChange={e => onChange(e)}
                        // maxlength="30"
                    />

                    <div className='cart_safety_msg'>
                        
                        <VerifiedUserIcon />
                        <span style={{color: '#0a8800', marginLeft: '3px', fontWeight: 500}}>
                            We use your school email to verify you're account.
                        </span>
                    </div>

                    {/* <div className='cart_safety_msg'>
                                        
                        <LockIcon />
                        <span>
                            OU Buy / Sell isn't associated with your school. Your info will never be shared.
                        </span>
                    </div> */}

                </div>

                {/* Submit */}
                <div style={{width: '100%', boxSizing:'border-box', padding:'0 10px', display:'flex', justifyContent:'flex-end'}}>
                    <Button 
                        disabled={school_email === auth.user.school_email}
                        variant="outlined" 
                        className={`sidebar__tweet save ${school_email === auth.user.school_email ? 'disabled' : ''}`}
                        onClick={school_email_todo}
                    >
                        Send PIN
                    </Button>
                </div>
            </div>
        </div>
    )
}

School_Email.propTypes = {
    nav: PropTypes.object.isRequired,
    setAlert: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
    nav: state.nav
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert
})(School_Email);
